import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.toArray(_ctx.store.state.base.alert.messages).length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`${_ctx.store.state.base.alert.color} border px-4 py-3 rounded`),
        role: "alert"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.base.alert.messages, (errorMessage) => {
          return (_openBlock(), _createElementBlock("div", {
            key: errorMessage.id
          }, _toDisplayString(errorMessage), 1))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}